<template>
    <div @click="selectNewAdmin" class="bg-primary-200 card cursor-pointer input-border-color group mb-0">
        <div class="card-body lg:px-4 px-3">
            <div class="flex flex-row items-center">
                <div class="lg:mr-4 mr-3">
                    <svg class="fill-current h-12 group-hover:text-primary-600 text-primary-500 w-12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M11 9h4v2h-4v4H9v-4H5V9h4V5h2v4zm-1 11a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"/></svg>
                </div>
                <div class="flex-1 lg:mr-4 mr-3">
                    <h4 class="text-base mb-1 mt-0">{{ $t('organization_details.new_admin') }}</h4>
                    <div>{{ $t('organization_details.new_admin_info') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        selectNewAdmin() {
            Bus.$emit('showAddAdminModal');
        },
    },
};
</script>
